import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import axios from 'axios';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ViewIcon from '@material-ui/icons/Visibility';
import CustomToolbarSelect from "./CustomToolbarSelect";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';

import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";

import  api from '../../common/api';

//import { Store } from "../../flux";

class PolicyAudit extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        param:'',
        policy_id: '',
        policy_name: '',
        contract_id:'',
        isLoaded: false,
        vehicles:[]
      }
    }

    async componentDidMount() {
      const param = this.getParams().query
      this.setState({policy_id: param});

      await this.getAudit(param);
      await this.getPolicy(param);

    }
   
   getParams(location) {
      const searchParams = new URLSearchParams(window.location.search);
      return {
        query: searchParams.get("id")
      };
    } 
    
    getPolicy= async (idPolicy) => {
      const token =localStorage.getItem('userToken')

      return await axios
           .get(api.policy().get(idPolicy),{ headers: {"Authorization" : `Bearer ${token}`} })
            .then(res => {
                this.setState({contract_id: res.data.contract.id})
            })
            .catch(err =>{console.log(err)
            })

    }


  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.8rem'
         }
        },
        MuiSvgIcon:{
          root: {
            fontSize: "1.39rem"
          }
        },
        MuiFab:{
          sizeSmall:{
            height: "35px",
            width: "35px"
          }
        }
      }
    });      
   getAudit = (policy_audit) => {
    const token =localStorage.getItem('userToken')

     return axios
              .get(api.policy().audit(policy_audit),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                let audit = res.data.audit
                if (res.data.tasks){
                  res.data.tasks.map((val, idx)=> {
                    audit.push(val.audit[0])
                  })
                }
                this.setState({isLoaded: true, data: audit})
              })
              .catch(err =>{console.log(err)
              })

    }


  render(){
     const policy_id = this.state.policy_id;
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "event",
      label: "Evento",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "user_id",
      label: "Usuario",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "old_values",
      label: "valores anteriores",
      options: {
       filter: false,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
            return (  
                <div>{JSON.stringify(value)}</div>
              );
          }
      }
     },
     {
      name: "new_values",
      label: "Nuevos valores",
      options: {
       filter: false,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
            return (  
                <div>{JSON.stringify(value)}</div>
              );
          }
      }
     },
     {
      name: "created_at",
      label: "Fecha",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     }
    ];

  const headerNames = [
    {
      name: 'id',
      download: true,
    },
    {
      name: 'patent',
      download: true,
    },
    {
      name: 'description',
      download: true,
    },
    {
      name: 'policy_id',
      download: true,
    }
  ];
  const footerNames = [];
  const options = {
    download: true,
    downloadOptions:{filename: `Lista de Vehículos ${this.state.policy_name}.csv`},
    onDownload: (buildHead, buildBody, columns, data) =>
      buildHead(headerNames) +
      buildBody(
        data.concat({
          index: Object.values(this.state.vehicles).length,
          data: footerNames,
        }),
    ),      
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    rowsPerPage: 10,
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar a CSV"        
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
    <MuiThemeProvider theme={this.getMuiTheme()}>

    <MUIDataTable
      title={`Auditoria ${this.state.policy_name}`}
      data={Object.values(this.state.data)}
      columns={columns}
      options={options}
     />
    <div style={{textAlign: "right"}}>
       <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/policies?idContract="+this.state.contract_id}>
          Volver
      </Button>
    </div>

    </MuiThemeProvider>

    );
  }


}

export default PolicyAudit;   